import script from "./StepNum.vue?vue&type=script&setup=true&lang=js"
export * from "./StepNum.vue?vue&type=script&setup=true&lang=js"

import "./StepNum.vue?vue&type=style&index=0&id=61b55590&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b55590"]])

export default __exports__